
function NotFound () {
    return (
    <div>
        PÁGINA NÃO ENCONTRADA.
    </div>
    )
}

export default NotFound